<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="withdrawal-page">
            <div class="common-header">
              <font style="vertical-align: inherit"><font style="vertical-align: inherit"> {{ $t('mine.Withdrawal1') }} </font></font>
            </div>
            <div class="withdrawal-page-wrapper">
              <div class="withdrawal-page-wrapper-bind-card">
                <div js-tab="3" class="mt-tabpage">
                  <div class="mt-tabpage-title">
                    <a href="javascript:;" @click="changqutype(0)" :class="qutype == 0 ? 'mt-tabpage-item mt-tabpage-item-cur' : 'mt-tabpage-item '"
                      ><img src="/static/image/company.png" style="margin-right: 5px" width="38" /><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Bank') }}</font></font></a
                    >
                    <a href="javascript:;" @click="changqutype(1)" :class="qutype == 1 ? 'mt-tabpage-item mt-tabpage-item-cur' : 'mt-tabpage-item '"
                      ><img src="/static/image/zgpay.png" width="38" style="margin-right: 5px" /><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.USDT') }}</font></font></a
                    >
                  </div>
                  <!--  -->
                  <div class="mt-tabpage-count">
                    <ul class="mt-tabpage-cont__wrap">
                      <li class="mt-tabpage-item">
                        <div class="bank-account-view">
                          <form class="ant-form ant-form-horizontal ant-form-hide-required-mark common-form-item">
                            <div class="ant-row ant-form-item" style="display: flex; align-items: center">
                              <div class="ant-col ant-col-6 ant-form-item-label">
                                <label class="ant-form-item-no-colon"
                                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Addaccount1') }}</font></font></label
                                >
                              </div>

                              <a href="javascript:;" @click="changBindShow(1)" v-if="qutype == 0" style="font-size: 14px"
                                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.bankpayment1') }}</font></font></a
                              >
                              <a href="javascript:;" @click="changBindShow(2)" v-if="qutype == 1" style="font-size: 14px"
                                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.USDTpayment1') }}</font></font></a
                              >
                            </div>

                            <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center" v-if="qutype == 0 && usercardLis.length != 0">
                              <div class="ant-col ant-col-6 ant-form-item-label">
                                <label class="ant-form-item-no-colon"
                                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Receiving1') }}</font></font></label
                                >
                              </div>
                              <div class="ant-col ant-col-14 ant-form-item-control">
                                <div class="ant-form-item-control-input">
                                  <div class="ant-form-item-control-input-content">
                                    <select class="ant-input" v-model="bankId" style="height: 48px">
                                      <option :value="null" selected  >{{ $t('mine.Receiving12') }}</option>
                                      <option :value="item.id" v-for="(item, index) in usercardLis" :key="index">{{ item.bank }} ---{{ item.bank_no }}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center" v-if="qutype == 1 && usdssLis.length != 0">
                              <div class="ant-col ant-col-6 ant-form-item-label">
                                <label class="ant-form-item-no-colon"
                                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Receiving1') }}</font></font></label
                                >
                              </div>
                              <div class="ant-col ant-col-14 ant-form-item-control">
                                <div class="ant-form-item-control-input">
                                  <div class="ant-form-item-control-input-content">
                                    <select class="ant-input" v-model="bankId" style="height: 48px" @change="changApiType">
                                      <option :value="null" selected  >{{ $t('mine.Receiving12') }}</option>

                                      <option :value="item.id" v-for="(item, index) in usdssLis" :key="index">{{ item.bank_owner }} ---{{ item.bank_no }}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center">
                              <div class="ant-col ant-col-6 ant-form-item-label">
                                <label class="ant-form-item-no-colon"
                                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Accountbalance1') }}</font></font></label
                                >
                              </div>

                              <div class="ant-col ant-col-14 ant-form-item-control">
                                <div class="ant-form-item-control-input">
                                  <div class="ant-form-item-control-input-content"><input readonly="readonly" type="text" :value="$store.state.userInfo.balance" class="ant-input" /></div>
                                </div>
                              </div>
                            </div>
                            <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center">
                              <div class="ant-col ant-col-6 ant-form-item-label">
                                <label class="ant-form-item-no-colon"
                                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Codesize1') }}</font></font></label
                                >
                              </div>

                              <div class="ant-col ant-col-14 ant-form-item-control">
                                <div class="ant-form-item-control-input">
                                  <div class="ant-form-item-control-input-content"><input readonly="readonly" type="text" :value="betAmount" class="ant-input" /></div>
                                </div>
                              </div>
                            </div>
                            <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center">
                              <div class="ant-col ant-col-6 ant-form-item-label">
                                <label class="ant-form-item-no-colon"
                                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Withdrawalamount1') }}</font></font></label
                                >
                              </div>
                              <div class="ant-col ant-col-14 ant-form-item-control">
                                <div class="ant-form-item-control-input">
                                  <div class="ant-form-item-control-input-content"><input v-model="amount" :placeholder="$t('mine.enterwithdrawal1')" type="text" class="ant-input" /></div>
                                </div>
                              </div>
                            </div>

                            <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center">
                              <div class="ant-col ant-col-6 ant-form-item-label">
                                <label for="withdrawAmount" class="ant-form-item-no-colon"
                                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.password1') }} </font></font></label
                                >
                              </div>
                              <div class="ant-col ant-col-14 ant-form-item-control">
                                <div class="ant-form-item-control-input">
                                  <div class="ant-form-item-control-input-content"><input :placeholder="$t('mine.enterpassword1')" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" autocomplete="new-password" v-model="password" type="password" class="ant-input" /></div>
                                </div>
                              </div>
                            </div>

                            <div v-if="qutype == 1">
                              <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center" v-if="chanmeyXi">
                                <div class="ant-col ant-col-6 ant-form-item-label">
                                  <label for="withdrawAmount" class="ant-form-item-no-colon"
                                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.transaction1') }}</font></font></label
                                  >
                                </div>
                                <div class="ant-col ant-col-14 ant-form-item-control">
                                  <div class="ant-form-item-control-input">{{ chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee : $store.state.userInfo.withdrawfeeusdttrc }} {{ $t('mine.USDT') }}</div>
                                </div>
                              </div>
                              <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center">
                                <div class="ant-col ant-col-6 ant-form-item-label">
                                  <label for="withdrawAmount" class="ant-form-item-no-colon"
                                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.USDTconversion1') }}</font></font></label
                                  >
                                </div>
                                <div class="ant-col ant-col-14 ant-form-item-control">
                                  <div class="ant-form-item-control-input">≈ {{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 : '0.00' }} {{ $t('mine.USDT') }} {{ $t('mine.exchange') }}{{ $store.state.userInfo.withdrawusdtrate }}</div>
                                </div>
                              </div>
                              <div class="ant-row ant-form-item common-form-item" style="display: flex; align-items: center">
                                <div class="ant-col ant-col-6 ant-form-item-label">
                                  <label for="withdrawAmount" class="ant-form-item-no-colon"
                                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.arrival') }}</font></font></label
                                  >
                                </div>
                                <div class="ant-col ant-col-14 ant-form-item-control">
                                  <div class="ant-form-item-control-input">{{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 - (chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee * 1 : $store.state.userInfo.withdrawfeeusdttrc * 1) : '0.00' }}</div>
                                </div>
                              </div>
                            </div>
                            <div class="ant-row ant-form-item common-form-item show-audit-detail">
                              <div class="ant-col ant-col-6 ant-form-item-label"><label title=" " class="ant-form-item-no-colon"></label></div>
                              <div class="ant-col ant-col-14 ant-form-item-control">
                                <div class="ant-form-item-control-input">
                                  <div class="ant-form-item-control-input-content">
                                    <div class="item-content-service">
                                      <font style="vertical-align: inherit"><font style="vertical-align: inherit"> {{ $t('mine.questions1') }} </font></font
                                      ><a @click="$parent.openKefu"
                                        ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Online1') }} </font></font></a
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ant-row ant-form-item common-form-item">
                              <div class="ant-col ant-col-6 ant-form-item-label"><label title=" " class="ant-form-item-no-colon"></label></div>
                              <div class="ant-col ant-col-14 ant-form-item-control">
                                <div class="ant-form-item-control-input">
                                  <div class="ant-form-item-control-input-content">
                                    <button v-if="qutype == 0" @click="withdraw" type="button" class="ant-btn apply-for-button ant-btn-lg">
                                      <span
                                        ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Apply1') }}</font></font></span
                                      >
                                    </button>
                                    <button v-if="qutype == 1" @click="withdraw1" type="button" class="ant-btn apply-for-button ant-btn-lg">
                                      <span
                                        ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Apply1') }}</font></font></span
                                      >
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="saving-tips" >
                              <span class="title"
                                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.measures1') }}</font></font></span
                              ><font style="vertical-align: inherit"
                                ><font style="vertical-align: inherit"> {{ $t('mine.platforms1') }}</font
                                ><font style="vertical-align: inherit">{{ $t('mine.limit1') }}</font></font
                              >
                            </div>
                          </form>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="el-dialog__wrapper" style="background: rgba(0, 0, 0, 0.4)" v-if="bindShow == 1">
        <div role="dialog" aria-modal="true" class="el-dialog" style="margin-top: 15vh">
          <div class="el-dialog__header">
            <span class="el-dialog__title"></span><button @click="changBindShow(0)" type="button" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          </div>
          <div class="el-dialog__body">
            <form class="el-form el-form--inline">
              <div class="el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank" class="el-form-item__label" style="width: 150px">{{ $t('mine.supporting1') }}</label>
                  <div class="el-form-item__content">
                    <el-select v-model="cardInfo.bank" :placeholder="$t('mine.supporting1')">
                      <el-option v-for="item in banklist" :key="item.bank_name" :label="item.bank_name" :value="item.bank_name"> </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 150px">{{ $t('mine.opening1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="cardInfo.bank_address" type="text" autocomplete="off" :placeholder="$t('mine.opening1') " class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 150px">{{ $t('mine.cardnumber1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="text" v-model="cardInfo.bank_no" autocomplete="off" oninput="value=value.replace(/[^0-9]/g,'')"  :placeholder="$t('mine.cardnumber1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 150px">{{ $t('mine.cardholder1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="text" v-model="cardInfo.bank_owner" autocomplete="off" :placeholder="$t('mine.cardholder1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 150px">{{ $t('mine.Paymentpassword1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="password" v-model="cardInfo.pay_pass" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" autocomplete="new-password" :placeholder="$t('mine.Paymentpassword1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <button type="button" class="el-button el-button--primary" @click="bindCard"><span>{{ $t('mine.Binding1') }}</span></button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="el-dialog__wrapper" style="background: rgba(0, 0, 0, 0.4)" v-if="bindShow == 2">
        <div role="dialog" aria-modal="true"  class="el-dialog" style="margin-top: 15vh">
          <div class="el-dialog__header">
            <span class="el-dialog__title"></span><button @click="changBindShow(0)" type="button"  class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          </div>
          <div class="el-dialog__body">
            <form class="el-form el-form--inline">
              <div class="el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank" class="el-form-item__label" style="width: 150px">{{ $t('mine.wallet1') }}</label>
                  <div class="el-form-item__content">
                    <!-- el-select -->
                    <el-select v-model="usdtInfo.bank_owner" :placeholder="$t('mine.wallet1')">
                      <el-option label="ERC20" value="ERC20"> </el-option>
                      <el-option label="TRC20" value="TRC20"> </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 150px">{{ $t('mine.USDTaddress1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="usdtInfo.bank_no" type="text" autocomplete="off" oninput="value=value.replace(/[\W]/g,'')" :placeholder="$t('mine.enterUSDTaddress1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 150px">{{ $t('mine.osenterpaymentpasswordit1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="password" v-model="usdtInfo.pay_pass" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" autocomplete="new-password"  :placeholder="$t('mine.osenterpaymentpasswordit1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <button type="button" class="el-button el-button--primary" @click="bindUsdss"><span>{{ $t('mine.Binding1') }}</span></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return {
      qutype: 0,
      amount: null,
      bankId: null,
      usercardLis: [],
      usdssLis: [],
      banklist: [],
      cardInfo: {},
      usdtInfo: {},
      password: null,
      bindShow: 0,
      chanmeyXi: null,
      betAmount: null,
    };
  },
  created() {
    let that = this;
    that.getBetAmount();
    that.getUsercard();
    that.getUsdssList();
    that.getBanklist();
  },
  methods: {
    getBetAmount() {
      let that = this;
      that.$apiFun
        .post('/api/getBetAmount', {})
        .then(res => {
          if (res.code == 200) {
            that.betAmount = res.data.bet_amount;
          }
        })
        .catch(res => {});
    },
    changApiType(e) {
      let that = this;
      let chanmeyXi = null;
      that.usdssLis.forEach(el => {
        if (el.id == that.bankId) {
          chanmeyXi = el.bank_owner;
          return;
        }
      });
      that.chanmeyXi = chanmeyXi;

      that.password = null;
      that.amount = null;
    },
    changBindShow(type) {
      let that = this;
      that.bindShow = type;
      that.cardInfo = {};
      that.usdtInfo = {};
    },
    bindUsdss() {
      let that = this;
      let usdtInfo = that.usdtInfo;
      usdtInfo.bank = 'USDT';
      if (usdtInfo.bank_no == null || usdtInfo.bank_no == '') {
        that.$parent.showTost(0, that.$t('mine.enterUSDTaddress1'));
        return;
      }
      if (!usdtInfo.bank_owner || usdtInfo.bank_owner == null) {
        that.$parent.showTost(0, that.$t('mine.wallet1'));
        return;
      }
      if (!usdtInfo.pay_pass) {
        that.$parent.showTost(0, that.$t('mine.osenterpaymentpasswordit1'));
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', usdtInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, res.message);
            that.changBindShow(0);
            that.getUsercard();
            that.getUsdssList();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, that.$t('mine.entername1'));
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, that.$t('mine.enterthebank1'));
        return;
      }
      if (!that.cardInfo.bank_address) {
        that.$parent.showTost(0, that.$t('mine.enteraddress1'));
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.$parent.showTost(0, that.$t('mine.enterbanknumber1'));
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, that.$t('mine.enterpaymentpassword1'));
        return;
      }
      if (that.cardInfo.bank_no.length < 8) {
        that.$parent.showTost(0, that.$t('mine.correctlength1'));
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, that.$t('mine.enterofpassword1'));
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, that.$t('mine.Bindingsuccessful1'));
          }
          that.changBindShow(0);
          that.getUsercard();
          that.getUsdssList();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changqutype(val) {
      let that = this;
      if (that.qutype == val) {
        return;
      }
      that.qutype = val;
      that.amount = null;
      that.password = null;
      that.bankId = null;
      this.chanmeyXi = null;
    },
    getUsercard() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
      });
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
    withdraw() {
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;

      if (amount < 100) {
        that.showTost(0, that.$t('mine.singlecannot1'));
        return;
      }
      if (!bank) {
        that.showTost(0, that.$t('mine.bankwithdrawto1'));
        return;
      }
      if (!password) {
        that.showTost(0, that.$t('mine.paymentpassword1'));
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, that.$t('mine.successfullywaiting1'));

            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    withdraw1() {
      //  amount: "100"
      // bank: 163
      // bank_owner: "TRC20"
      // password: "1"
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.showTost(0, that.$t('mine.selectUSDTaddress1'));
        return;
      }
      if (amount < 100) {
        that.showTost(0, that.$t('mine.singlecannot1'));
        return;
      }

      if (!password) {
        that.showTost(0, that.$t('mine.paymentpassword1'));
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, that.$t('mine.successfullywaiting1'));
            that.chanmeyXi = null;
            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/mt-style.css';
.mt-tabpage-title {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.mt-tabpage-title .mt-tabpage-item {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/withdraw.vue